// Single source of truth for expansion kits and which devices each one supports.
// Shared by ExpansionKitSelection (device picker) and MakeAdmin (kit dropdown).
//
// `src`     -> renderImage key for the kit's picture
// `devices` -> devices that support this kit (used both to show device cards
//              and to decide which kits an admin can tag a subprogram with)
export const EXPANSION_KITS = {
    makeyExpansionKit: {
        name: 'Makey Expansion kit',
        src: 'makeyExpansionKit',
        devices: ['Toki'],
    },
    ioExpansionKit1: {
        name: 'IO Expansion kit 1',
        src: 'PokiRoverKit',
        devices: ['Toki', 'Moki', 'Poki'],
    },
    ioExpansionKit2: {
        name: 'IO Expansion kit 2',
        src: 'ioExpansionKit2',
        devices: ['Moki', 'Poki'],
    },
    roverExpansionKit1: {
        name: 'Rover Expansion kit 1',
        src: 'PokiRoverKit',
        devices: ['Toki', 'Poki'],
    },
    roverExpansionKit2: {
        name: 'Rover Expansion kit 2',
        src: 'roverExpansionKit2',
        devices: ['Toki', 'Poki'],
    },
    woofExpansionKit3: {
        name: 'Woof Expansion kit 3',
        src: 'woofExpansionKit3',
        devices: ['Poki'],
    },
    roarmExpansionKit4: {
        name: 'RoArm Expansion kit 4',
        src: 'roarmExpansionKit4',
        devices: ['Poki'],
    },
    walkerExpansionKit5: {
        name: 'Walker Expansion kit 5',
        src: 'walkerExpansionKit5',
        devices: ['Poki'],
    },
    omniBotRoverExpansionKit: {
        name: 'Omni bot Rover Expansion kit',
        src: 'omniBotRoverExpansionKit',
        devices: ['Moki'],
    },
    omniBotShooterExpansionKit: {
        name: 'Omni bot Shooter Expansion kit',
        src: 'omniBotShooterExpansionKit',
        devices: ['Moki'],
    },
    spidyExpansionKit: {
        name: 'Spidy Expansion kit',
        src: 'spidyExpansionKit',
        devices: ['Moki'],
    },
    integratedRoboticsExpansionKit: {
        name: 'Integrated Robotics Expansion kit',
        src: 'integratedRoboticsExpansionKit',
        devices: [],
    },
}

// Returns the kits a given device supports, as [{ id, name, src, devices }].
export const getKitsForDevice = (device) =>
    Object.entries(EXPANSION_KITS)
        .filter(([, kit]) => kit.devices.includes(device))
        .map(([id, kit]) => ({ id, ...kit }))
